import { XMarkIcon } from '@heroicons/react/24/outline'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Cookies from 'universal-cookie'
import { setSecureCookieWithConsent } from '../utils/cookies'
import { hasConsentForCategory } from '../utils/cookieConsent'

function Banner() {
    const [isVisible, setIsVisible] = useState(true)
    const cookies = new Cookies()
    const { t } = useTranslation()
    useEffect(() => {
        // Check if banner has been dismissed before
        const bannerDismissed = cookies.get('bannerDismissed')
        if (bannerDismissed) {
            setIsVisible(false)
        }
    }, [])

    const handleDismiss = () => {
        // Set cookie to expire in 2 days
        setSecureCookieWithConsent('bannerDismissed', true, { maxAge: 60 * 60 * 24 * 2 }, (cookieName) => hasConsentForCategory('functional'))
        setIsVisible(false)
    }

    if (!isVisible) return null

    return (
        <div className='md:pl-64'>
            <div className="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-900 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
                <div
                    aria-hidden="true"
                    className="absolute left-[max(-7rem,calc(50%-52rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
                >
                    <div
                        style={{
                            clipPath: 'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
                        }}
                        className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-blue-900 to-blue-600 opacity-30"
                    />
                </div>
                <div
                    aria-hidden="true"
                    className="absolute left-[max(45rem,calc(50%+8rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
                >
                    <div
                        style={{
                            clipPath: 'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
                        }}
                        className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-blue-800 to-blue-500 opacity-30"
                    />
                </div>
                <p className="text-sm/6 text-white font-bold">
                    <a href="/rewards">
                        {t("Banner.bannerPartOne")}
                        <svg viewBox="0 0 2 2" aria-hidden="true" className="mx-2 inline size-0.5 fill-current">
                            <circle r={1} cx={1} cy={1} />
                        </svg>
                        {t("Banner.bannerPartTwo")}&nbsp;
                        <span aria-hidden="true">&rarr;</span>
                    </a>
                </p>
                <div className="flex flex-1 justify-end">
                    <button type="button" className="-m-3 p-3 focus-visible:outline-offset-[-4px]" onClick={handleDismiss}>
                        <span className="sr-only">Dismiss</span>
                        <XMarkIcon aria-hidden="true" className="size-5 text-white" />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Banner
